import { RichMediaValue } from '@/interface/media';
import { downloadImageAndUpload } from '@/utils/file';

import { emitRichMediaPIC } from '../../change-data';
import { UploadOptions } from '../../service';

const blurPreFix = '?imageMogr2/blur/50x50';

export const getBlur = async (
  imageUrl: string,
  data?: RichMediaValue,
  options?: UploadOptions,
) => {
  let imageBlur = {};
  let blurUrl = imageUrl + blurPreFix;
  const { url = '', localPath } = await downloadImageAndUpload(blurUrl, options);
  blurUrl = url ? url : blurUrl;
  imageBlur = {
    ...data,
    url: {
      url: blurUrl,
      localPath,
      name: data?.url?.name,
    },
  };
  emitRichMediaPIC(blurUrl);
  return imageBlur;
};
